module.exports = "<span class=\"option-text\"><ng-content></ng-content></span>"